import * as React from 'react';
import './ChooseUs.styles.scss'
import Typography from '@mui/material/Typography';
import queueIcon from "../../../src/assets/svg/Queue up wait line up (1).svg";
import lowPrice from "../../../src/assets/svg/Online shopping credit card payment.svg";
import easyApply from "../../../src/assets/svg/Rocket space astronomy spaceship satellite.svg";
import useTranslation from '../../translations/use-translation';

const ChooseUs = () => {
  const translate = useTranslation();
  const cards = [
    { icon: queueIcon, titleKey: 'CHOOSE_US_NO_QUEUE',     descKey: 'CHOOSE_US_NO_QUEUE_DESCRIPTION' },
    { icon: lowPrice,  titleKey: 'CHOOSE_US_LOW_CHARGES',  descKey: 'CHOOSE_US_LOW_CHARGES_DESCRIPTION' },
    { icon: easyApply, titleKey: 'CHOOSE_US_EASY_APPLY',   descKey: 'CHOOSE_US_EASY_APPLY_DESCRIPTION' },
  ];

  return (
    <div className='oa-service-choose-cards'>
      <Typography variant="h6" gutterBottom className="choose-us-heading">
        {translate('CHOOSE_US_HEADING')}
      </Typography>
      <p className="choose-us-sub">Everything you need, all in one place</p>
      <div className='oa-choose-card-container'>
        {cards.map((card) => (
          <div className='oa-choose-card' key={card.titleKey}>
            <div className='icon-circle'>
              <img src={card.icon} alt={card.titleKey} />
            </div>
            <Typography variant="h6" gutterBottom>
              {translate(card.titleKey)}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {translate(card.descKey)}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
}
export default ChooseUs;
